export const SOCKETIOENDPOINTS = {
  ENDPOINT: {
    getNotification: '/getNotification'
  }
};
